import type { ContractBagProtectionResponse } from '~/domain/BagProtection/contractBagProtection';
import type { ContractBagProtectionResponseDTO } from '~/dto/BagProtection/contractBagProtection';

export const contractBagProtectionDTOToContractBagProtection = ({
  resultData: resultDataDto,
  message,
  errors,
  success,
}: ContractBagProtectionResponseDTO): ContractBagProtectionResponse => {
  const resultData = resultDataDto
    ? {
        certificateCode: resultDataDto?.codigoCertificado,
        insuredDocument: resultDataDto?.cpfCnpjSegurado,
        productCode: resultDataDto.codigoProduto,
        policyNumber: resultDataDto.numeroApolice,
        companyDocument: resultDataDto.cnpjEmpresa,
      }
    : undefined;

  return {
    resultData,
    message,
    success,
    errors: errors.map((error) => ({
      code: error.errorCode,
      message: error.errorMessage,
    })),
  };
};
